export const services = [
  {
    id: 'ac-repair',
    name: 'AC Repair & Installation',
    description: 'Expert AC repair and installation service center',
    icon: 'AirVent',
    metaTitle: 'AC Repair & Installation Service Center in India | Parakh Services',
    metaDescription: 'Professional AC repair and installation service center for all brands. Split AC, Window AC repair, installation and maintenance services across India.'
  },
  {
    id: 'refrigerator-repair',
    name: 'Refrigerator Repair',
    description: 'Professional refrigerator repair service center',
    icon: 'Box',
    metaTitle: 'Refrigerator Repair Service Center | Parakh Services',
    metaDescription: 'Expert refrigerator repair service center for all brands. Same day service with warranty.'
  },
  {
    id: 'washing-machine-repair',
    name: 'Washing Machine Repair',
    description: 'Expert washing machine repair service center',
    icon: 'WashingMachine',
    metaTitle: 'Washing Machine Repair Service Center | Parakh Services',
    metaDescription: 'Professional washing machine repair service center for all brands. Front load and top load repair with warranty.'
  },
  {
    id: 'tv-repair',
    name: 'TV Repair',
    description: 'Professional TV repair service center',
    icon: 'Tv',
    metaTitle: 'TV Repair Service Center - LCD, LED & Smart TV | Parakh Services',
    metaDescription: 'Expert TV repair service center for all brands. LCD, LED and Smart TV repair with warranty.'
  },
  {
    id: 'water-purifier-repair',
    name: 'RO & Water Purifier Repair',
    description: 'Expert water purifier repair service center',
    icon: 'Droplets',
    metaTitle: 'RO Water Purifier Repair Service Center | Parakh Services',
    metaDescription: 'Professional RO system and water purifier repair service center. All brands RO repair and maintenance.'
  },
  {
    id: 'microwave-repair',
    name: 'Microwave Repair',
    description: 'Professional microwave oven repair service center',
    icon: 'Wrench',
    metaTitle: 'Microwave Oven Repair Service Center | Parakh Services',
    metaDescription: 'Expert microwave oven repair service center for all brands. Same day service with warranty.'
  }
] as const;

export type Service = typeof services[number];
export type ServiceId = Service['id'];

export function getService(id: ServiceId): Service | undefined {
  return services.find(service => service.id === id);
}